<shared-toolbar title="Acción">
  <shared-search-field (inputValue)="fielInput = $event" [data]="dataSource" />
  <!-- <shared-button
    (click)="modalAction()"
    [typeBtn]="'button'"
    [color]="'accent'"
    [icon]="'add'"
    >Agregar
  </shared-button> -->
</shared-toolbar>
<mat-card class="mt-4 p-0 overflow-hidden">
  <mat-card-content class="overflow-y-hidden overflow-x-scroll">
    <table mat-table class="w-full" [dataSource]="dataSource" matSort>
      <!-- Position Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre</th>
        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="actioncode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Código</th>
        <td mat-cell *matCellDef="let element">
          {{ element.actioncode | uppercase }}
        </td>
      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Descripción</th>
        <td mat-cell *matCellDef="let element">{{ element.description }}</td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo</th>
        <td mat-cell *matCellDef="let element">{{ element.type }}</td>
      </ng-container>

      <ng-container class="flex justify-content-center" matColumnDef="options">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <!-- <button (click)="modalAction(element)" mat-icon-button>
            <mat-icon>edit</mat-icon>
          </button> -->
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">
          No hay resultados para la busqueda: {{ fielInput }}
        </td>
      </tr>
    </table>
    <br />
    <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
    </mat-paginator>
  </mat-card-content>
</mat-card>
